import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["button", "todayBox", "balance", "candyJar", "disabledButton", "tickedDaySevenBox", "mobileButton", "mobileDisabledButton", "nextDailyRewardCountdownTimer", "nextDailyRewardCountdownTimerMobile"];

  connect() {
    let countdownTimer = this.nextDailyRewardCountdownTimerTarget
    let countdownTimerMobile = this.nextDailyRewardCountdownTimerMobileTarget
    this._displayCountdownTime(countdownTimer, countdownTimerMobile)
  }

  claimCandy() {
    this._updateCandyBalance();
    this._updateButtonState();
    this._updateProgressState();
  }

  _updateProgressState() {
    if(parseInt(this.todayBoxTarget.dataset.points) == 60) {
      this.todayBoxTarget.classList.remove("today-box");
      this.todayBoxTarget.classList.add("ticked-box");
    } else if(parseInt(this.todayBoxTarget.dataset.points) != 100){
      this.todayBoxTarget.classList.remove("today-box");
      this.todayBoxTarget.classList.add("ticked-box");
    } else {
      this.todayBoxTarget.classList.add('d-none');
      this.tickedDaySevenBoxTarget.classList.remove('d-none')
    }
  }

  _updateCandyBalance(){
    let todayReward = parseInt(this.todayBoxTarget.dataset.points);
    let candyBalance = parseInt(this.balanceTarget.innerHTML);
    let updatedCandyBalance = candyBalance + todayReward;
    this.balanceTarget.innerHTML = updatedCandyBalance
  }

  _updateButtonState() {
    this.buttonTarget.classList.remove('btn-primary');
    this.buttonTarget.classList.add('btn-secondary');
    this.buttonTarget.hidden = true;
    this.disabledButtonTarget.hidden = false;

    this.mobileButtonTarget.classList.remove('btn-primary');
    this.mobileButtonTarget.classList.add('btn-secondary');
    this.mobileButtonTarget.hidden = true;
    this.mobileDisabledButtonTarget.hidden = false;
  }

  _displayCountdownTime(countdownTimer, countdownTimerMobile) {
     var currentDatetime = new Date();
     var tomorrow = new Date();
     tomorrow.setDate(new Date().getDate()+1);
     var nextBeginningOfTheDayTimeStamp = new Date(tomorrow).setUTCHours(0,0,0,0);

     var secondsFromNow = (nextBeginningOfTheDayTimeStamp - new Date().getTime()) / 1000;
     var nextDailyRewardTimestamp = new Date().setSeconds(new Date().getSeconds() + secondsFromNow)

     $('#' + countdownTimer.id).countdown(nextDailyRewardTimestamp, function(event){
       $(this).text(event.strftime(`%-H:%M:%S`))
     });
     $('#' + countdownTimerMobile.id).countdown(nextDailyRewardTimestamp, function(event){
       $(this).text(event.strftime(`%-H:%M:%S`))
     });
   }
}
